"use client";

import Link from "next/link";
import GradientButton from "@repo/ui/components/ui/gradient-button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@repo/ui/components/ui/carousel";
import CategoriesTabs from "@components/categories-tabs";
import { cn } from "@repo/ui/lib/utils";
import { Button } from "@repo/ui/components/ui/button";
import HowWorks from "@components/how-works";
import Warranties from "@components/warranties";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import AlgoliaSearch from "@components/search/algolia-search";
import { searchQueryUrl } from "@/algolia/search-url";

export default function Home() {
  const t = useTranslations("Home");
  const router = useRouter();
  const heroKeys = ["slide0", "slide1", "slide2", "slide3"] as const;
  // const howWorksKeys = ["step1", "step2", "step3", "step4"] as const;

  function navigateToResults(search: string) {
    router.push(searchQueryUrl(search));
  }

  function onSearch(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const search = String(formData.get("search") ?? "");
    navigateToResults(search);
  }

  return (
    <div>
      <div className="relative -m-[40px] max-md:-m-[24px] flex items-center flex-col mb-[120px] max-md:mb-[80px]">
        <div className="hidden max-md:block absolute bottom-[0] bg-transparent w-[85vw] h-[50vw] rounded-full opacity-30 shadow-[0_12px_60px_40px_rgba(249,246,247,1)]"></div>
        <Carousel
          className="w-full"
          forceTheme="dark"
          scrollSnapClass="md:justify-end md:right-[140px] md:bottom-[55px]"
        >
          <CarouselContent>
            {heroKeys.map((key) => (
              <CarouselItem
                key={key}
                className={cn(
                  "relative h-[calc(100vh-107px-70px-100px)] max-md:h-[500px] flex items-center justify-center max-md:bg-center bg-cover bg-no-repeat",
                  { "bg-top": t(`hero.${key}.position`) === "top" },
                  { "bg-bottom": t(`hero.${key}.position`) === "bottom" },
                )}
                style={{ backgroundImage: `url(${t(`hero.${key}.img`)})` }}
              >
                <div className="absolute inset-0 bg-primary-white dark:bg-primary-black opacity-10"></div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
        <div className="absolute inset-0 flex flex-col justify-end items-center pointer-events-none pb-[150px] max-md:pb-[80px]">
          <h1 className="z-10 py-2 leading-none text-primary-white text-center max-md:text-[30px] bg-primary-magenta">
            {t(`hero.slide1.title`)}
            {/*<p className="mt-6 max-md:mt-4 text-[30px] max-md:text-[22px] leading-[1.2] font-normal">*/}
            {/*  {t.rich("hero.slide1.subtitle", {*/}
            {/*    br: () => <br />,*/}
            {/*  })}*/}
            {/*</p>*/}
          </h1>
          <div className="mt-10 max-md:mt-8 min-w-[500px] max-md:min-w-[290px] text-left pointer-events-auto">
            <AlgoliaSearch
              onSearch={onSearch}
              onSuggestionSelect={navigateToResults}
            />
          </div>
        </div>
        <Link
          className="absolute bottom-[0] translate-y-[50%] h-[250px] w-[250px] max-md:h-[150px] max-md:w-[150px]"
          href="/search"
        >
          <GradientButton icon="Search" animation={true} />
        </Link>
      </div>
      <div className="flex items-center flex-col">
        {/*<h2 className="my-[40px] max-md:my-[20px] text-center max-md:text-[30px] leading-none">*/}
        {/*  {t.rich("info1", {*/}
        {/*    br: () => <br />,*/}
        {/*  })}*/}
        {/*</h2>*/}
        {/*<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[20px] mb-[100px] max-md:mb-[40px]">*/}
        {/*  {howWorksKeys.map((key, index: number) => (*/}
        {/*    <GradientCard*/}
        {/*      key={t(`how-works.${key}.title`)}*/}
        {/*      heading={`0${index + 1}`}*/}
        {/*      title={t(`how-works.${key}.title`)}*/}
        {/*      content={t(`how-works.${key}.body`)}*/}
        {/*    />*/}
        {/*  ))}*/}
        {/*</div>*/}
        <h2 className="text-center mb-[40px] max-md:mb-[20px] leading-[1.2] max-md:text-[24px] font-light">
          {t.rich("info2", {
            strong: (chunks) => <strong className="font-bold">{chunks}</strong>,
            section: (chunks) => (
              <div className="mt-[30px] max-md:mt-[20px] max-md:mx-[30px]">
                {chunks}
              </div>
            ),
            br: () => <br />,
          })}
        </h2>
        <Link href="/#how-works">
          <Button className="mb-[60px]" variant="default">
            {t("info2_CTA")}
          </Button>
        </Link>
        <h2 className="text-center mb-[40px] max-md:mb-[20px] leading-none max-md:text-[30px]">
          {t.rich("info3", {
            strong: (chunks) => <strong className="font-bold">{chunks}</strong>,
            br: () => <br />,
          })}
        </h2>
        <CategoriesTabs />
        <HowWorks />
        <Warranties />
      </div>
      {/*<div className="-m-[40px] max-md:-m-[20px] mt-[60px] px-[40px] py-[60px] flex flex-col items-center bg-secondary-gray2 dark:bg-secondary-black">*/}
      {/*  <h2 className="text-center mb-[40px] max-md:mb-[20px] leading-none max-md:text-[20px]">*/}
      {/*    {t("info4")}*/}
      {/*  </h2>*/}
      {/*  <Link*/}
      {/*    className="h-[250px] w-[250px] max-md:h-[150px] max-md:w-[150px]"*/}
      {/*    href="/search"*/}
      {/*  >*/}
      {/*    <GradientButton icon="Search" />*/}
      {/*  </Link>*/}
      {/*</div>*/}

      {/*<div className="text-center leading-[1.2] text-[30px] max-md:text-[18px] -m-[40px] max-md:-m-[20px] mt-[60px] px-[180px] py-[80px] max-md:px-[20px] bg-secondary-gray2 dark:bg-secondary-black">*/}
      {/*  {t.rich("info5", {*/}
      {/*    strong: (chunks) => <strong className="font-bold">{chunks}</strong>,*/}
      {/*    br: () => <br />,*/}
      {/*  })}*/}
      {/*</div>*/}

      {/*<div className="relative flex justify-center items-center my-20">*/}
      {/*  <YoutubeVideo*/}
      {/*    heading="La rivoluzione dello shopping online"*/}
      {/*    YTid="7YoACc3AWBg"*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  );
}
